import axios from 'axios';

export async function getUsers (cancelToken: any) {
  return axios.get(`${process.env.VITE_API_URL}api/users`, {
    cancelToken: cancelToken
  });
}

export async function createUser (userData: any) {
  return axios.post(`${process.env.VITE_API_URL}user`, userData);
}

export async function deleteUser (ids: any) {
  return axios.delete(`${process.env.VITE_API_URL}user?id=${ids.toString()}`);
}

export async function updateUserStatus (ids: any, status: number) {
  return axios.patch(`${process.env.VITE_API_URL}/api/user/status`, {
    id: ids.toString(),
    status
  });
}

export async function editUser (userData: any) {
  return axios.put(`${process.env.VITE_API_URL}user`, userData);
}

export async function getPatientFamilyUser (patientId: number | undefined, cancelToken: any) {
  return axios.get(`${process.env.VITE_API_URL}api/user/patientfamily?patientId=${patientId}`, {
    cancelToken: cancelToken
  });
}

export async function createPatientFamilyUser (userData: any) {
  return axios.post(`${process.env.VITE_API_URL}api/user/patientfamily`, userData);
}

export async function editPatientFamilyUser (userData: any) {
  return axios.patch(`${process.env.VITE_API_URL}api/user/patientfamily`, userData);
}

export async function getUserById (id: any, cancelToken: any) {
  return axios.get(`${process.env.VITE_API_URL}user?id=${id}`);
}

export async function ResetPassowrdByAdmin (data: any) {
  return axios.post(`${process.env.VITE_API_URL}/api/user/admin_reset_password`, data);
}

export async function getUserPriorityNotes (cancelToken?: any) {
  return axios.get(`${process.env.VITE_API_URL}api/priority-notes`, {
    cancelToken
  });
}

export async function clearUserPriorityNote (noteId: number) {
  return axios.patch(`${process.env.VITE_API_URL}api/priority-notes/${noteId}`);
}

export async function getUsersForPriorityNotes (patientId: number, cancelToken?: any) {
  return axios.get(`${process.env.VITE_API_URL}api/priority-notes/users?patientId=${patientId}`, {
    cancelToken
  });
}
